import { Injectable } from '@angular/core';
import {Headers, RequestOptions} from '@angular/http';

@Injectable()
export class VideoTitlesService { }


// WEBPACK FOOTER //
// ./src/app/youtube-video/video-search/video-titles.service.ts